import api from '@/services/Api';

export default {
    getQuestions(){
        return api.get('/api/v1/questions')
    },
    getQuestion(slugQuestion){
        return api.get('/api/v1/question/' + slugQuestion)
    },
    setAnswear(slug, replies){
        return api.post('/api/v1/questions/'+slug+'/reply', replies)
    }
}